<!--
Copyright 2017 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <modal id="project-new" :state="state" :hideable="!awaitingResponse" backdrop
    @hide="$emit('hide')" @shown="$refs.name.focus()">
    <template #title>{{ $t('title') }}</template>
    <template #body>
      <div class="modal-introduction">
        <p>{{ $t('introduction[0]') }}</p>
        <i18n tag="p" path="moreInfo.helpArticle.full">
          <template #helpArticle>
            <doc-link to="central-projects/">{{ $t('moreInfo.helpArticle.helpArticle') }}</doc-link>
          </template>
        </i18n>
      </div>
      <form @submit.prevent="submit">
        <form-group ref="name" v-model.trim="name"
          :placeholder="$t('field.name')" required autocomplete="off"/>
        <div class="modal-actions">
          <button type="submit" class="btn btn-primary"
            :disabled="awaitingResponse">
            {{ $t('action.create') }} <spinner :state="awaitingResponse"/>
          </button>
          <button type="button" class="btn btn-link"
            :disabled="awaitingResponse" @click="$emit('hide')">
            {{ $t('action.cancel') }}
          </button>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import DocLink from '../doc-link.vue';
import FormGroup from '../form-group.vue';
import Modal from '../modal.vue';
import Spinner from '../spinner.vue';
import request from '../../mixins/request';
import { noop } from '../../util/util';

export default {
  name: 'ProjectNew',
  components: { DocLink, FormGroup, Modal, Spinner },
  mixins: [request()],
  props: {
    state: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      awaitingResponse: false,
      name: ''
    };
  },
  watch: {
    state(state) {
      if (!state) this.name = '';
    }
  },
  methods: {
    submit() {
      this.post('/projects', { name: this.name })
        .then(({ data }) => {
          this.$emit('success', data);
        })
        .catch(noop);
    }
  }
};
</script>

<i18n lang="json5">
{
  "en": {
    // This is the title at the top of a pop-up.
    "title": "Create Project",
    "introduction": [
      "Projects group Forms and App Users together to make them easier to organize and manage, both on this website and on your data collection device."
    ]
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "title": "Vytvořit Projekt",
    "introduction": [
      "Skupiny projektů Formulářů a Uživatelů aplikací společně usnadňují jejich organizaci a správu, a to jak na tomto webu, tak v zařízení pro sběr dat."
    ]
  },
  "de": {
    "title": "Projekt erstellen",
    "introduction": [
      "Projekte gruppieren Formulare und App-Benutzer, um es zu vereinfachen, sie zu organisieren und zu verwalten, sowohl auf dieser Webseite als auch auf Ihrem Datenerfassungsgerät."
    ]
  },
  "es": {
    "title": "Crear proyecto",
    "introduction": [
      "Los proyectos agrupan formularios y Usuarios de aplicativos móviles juntos para facilitar su organización y manejo, tanto en este sitio web como en su dispositivo de recolección de datos."
    ]
  },
  "fr": {
    "title": "Créer un projet",
    "introduction": [
      "Les projets regroupent les formulaires et les utilisateurs mobiles afin de les rendre plus faciles à organiser et à gérer, tant sur ce site web que sur votre appareil de collecte de données."
    ]
  }
}
</i18n>
